import Home from './Home';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/home/") {
      window.location.replace("/home"); // Redirect to /home without opening a new tab
    }
  }, []);
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="" element={<Navigate to="/home" replace />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        {/* <Route path="/home/" element={<Navigate to="/home" replace />} /> */}
      </Routes>
    </Router>

  );
}

export default App;
